import { InteractivityActionTypeValue } from '../InteractivityActionTypeValue';
import type { ConditionalInteractivityActionSnapshotOut } from './ConditionalInteractivityAction';

export const conditionalInteractivityActionSnapshotMetadata = {
  typeId: InteractivityActionTypeValue.Conditional,

  innerInteractivityActions: {
    fromSnapshot(sn: ConditionalInteractivityActionSnapshotOut) {
      return sn.cases.map(c => c.then);
    },
  },
};
